export const background = '#2B8AC6'
export const color = '#fff'
export const highlight = '#a00'
